module.exports = __webpack_public_path__ + "dbbe6430d4a193333de80afb750e3932.png";